import { karateR0Fetch } from "./karateR0ApiClient.js";

export async function fetchAdminMembers(params = {}) {
  const query = new URLSearchParams();
  if (params.search) query.set("search", params.search);
  if (params.dojoId) query.set("dojoId", params.dojoId);
  if (params.status) query.set("status", params.status);
  const qs = query.toString();
  const { response, body } = await karateR0Fetch(`/admin/members${qs ? `?${qs}` : ""}`);
  return { ok: response.ok, status: response.status, body };
}

export async function fetchAdminMemberHealth(id) {
  const { response, body } = await karateR0Fetch(`/admin/members/${id}/health`);
  return { ok: response.ok, status: response.status, body };
}

export async function createMember(payload) {
  const { response, body } = await karateR0Fetch("/admin/members", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function updateMember(id, payload) {
  const { response, body } = await karateR0Fetch(`/admin/members/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function setMemberStatus(id, status, expectedUpdatedAt) {
  const { response, body } = await karateR0Fetch(`/admin/members/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status, expectedUpdatedAt }),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function fetchSenseiMembers(params = {}) {
  const query = new URLSearchParams();
  if (params.search) query.set("search", params.search);
  if (params.status) query.set("status", params.status);
  const qs = query.toString();
  const { response, body } = await karateR0Fetch(`/sensei/members${qs ? `?${qs}` : ""}`);
  return { ok: response.ok, status: response.status, body };
}

export async function updateSenseiMember(id, payload) {
  const { response, body } = await karateR0Fetch(`/sensei/members/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function fetchDojosForSelect() {
  const { response, body } = await karateR0Fetch("/admin/dojos?status=ACTIVE");
  if (!response.ok) return { ok: false, status: response.status, body };
  return {
    ok: true,
    status: response.status,
    body: {
      dojos: (body.dojos ?? []).map((d) => ({ id: d.id, name: d.name, city: d.city })),
    },
  };
}
